export const PAYMENT_SUCCESS_HEADER = {
    RESTAURANT_NAME: "restaurant-name",
    RESTAURANT_ADDRESS: "restaurant-address",
    CROSS_ICON: "header-cross-icon",
};
